import React, { Component } from 'react';
import {
    Portlet,
    PortletBody,
    PortletHeader
} from "../../../partials/content/Portlet";
import { store } from 'react-notifications-component';
import { Container, Row, Col, Card, Accordion, Badge, Table, Button, Form, Popover, OverlayTrigger } from 'react-bootstrap';
import FilterComponent from '../../../partials/layout/FilterComponent';
import UltimatePagination from '../../../partials/layout/PaginationComponent';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as constants from '../../../constants';
import { formatDateTime, formatAmount } from '../../../../_metronic/utils/utils';
import { TokenPaymentsServices } from './TokenPayments.service';
import { commonServices } from '../../../../app/commonServices/commonServices';
import { TokenStatusPill } from '../../../partials/layout/TokenPaymentDetailsComponent';

class TokenPayments extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
            tokenPayments: null,
            paymentDetailsData: {},
            openKey: null,
            page: 1,
            total: undefined,
            offset: 0,
            limit: 100,
            totalCount: 0,
            filters: {
                minimumDatetime: null,
                maximumDatetime: null,
                status: undefined,
                tokenStatus: 4,
                listingId: undefined,
                cityIds: [],
                cityNames: [],
                formattedCities: [],
                preSelectedCities: null,
            }

        };
    }

    componentDidMount() {
        this.fetchData();
        this.getCities();
    }

    fetchData = async () => {
        this.setState({ isFetching: true });
        const { minimumDatetime, maximumDatetime, status, listingId, cityNames, tokenStatus } = this.state.filters;
        const { offset, limit } = this.state;

        const { employeeId, cityNames: userCityNames = [] } = this.props.userDetails || {};
        // console.log('Logged-in user:', { employeeId, userCityNames });

        const data = {
            DateFrom: minimumDatetime || null,
            DateTo: maximumDatetime || null,
            ListingId: Number(listingId) || 0,
            Cities: cityNames && cityNames.length > 0 ? cityNames.join(',') : '',
            BookingStatus: tokenStatus !== undefined ? tokenStatus : -1,
            UserCityMapping: userCityNames.join(','),
            EmployeeCode: employeeId || '',
            Offset: offset,
            Limit: limit
        };
        //console.log(data);

        const result = await TokenPaymentsServices.getTokenListingList(data);
        if (result && result.status === 200) {
            const totalCount = result.data?.totalCount || 0;
            const totalPageNo = Math.ceil(totalCount / limit);
            this.setState({
                tokenPayments: result.data?.data || [],
                totalCount: totalCount,
                total: totalPageNo === 0 ? 1 : totalPageNo,
                isFetching: false
            });
        } else {
            this.setState({ tokenPayments: [], isFetching: false });
            store.addNotification({
                title: "Error!",
                message: `${result?.response?.data?.message || 'Something went wrong!'} (${result?.response?.status || ''})`,
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 5000,
                    onScreen: true,
                    showIcon: true,
                    pauseOnHover: true
                }
            });
        }
    };

    handleFilterChildData = (childData) => {
        // console.log("Child Data: " + JSON.stringify(childData));
        if (childData) {
            this.setState(prevState => ({
                filters: {
                    ...prevState.filters,
                    listingId: childData.listingId,
                    minimumDatetime: childData.minimumDatetime,
                    maximumDatetime: childData.maximumDatetime,
                    status: childData.status?.[0],
                    tokenStatus: childData.tokenStatus !== undefined && childData.tokenStatus !== -1 && childData.tokenStatus !== "-1" ? parseInt(childData.tokenStatus) : undefined,
                    cityIds: childData.cityIds || [],
                    cityNames: (childData.selectedCities || []).map(city => city.label)
                },
                page: 1,
                offset: 0,
                limit: 10
            }), () => {
                this.fetchData();
            });
        }
    };

    onPageChange = async (page) => {
        const { limit } = this.state;
        const offset = (limit * (page - 1));
        await this.setState({ page, offset });
        await this.fetchData();
    };


    // Property name click => PMS property-profile page
    openPropertyProfile = async (e, listingId) => {
        e.stopPropagation(); // stop accordion toggle
        const house = await TokenPaymentsServices.getHouseByListingId(listingId);
        if (house && house.id) {
            this.props.history.push(`/property-profile/${house.id}`);
        } else {
            store.addNotification({
                message: `Listing #${listingId} not found.`,
                type: "warning",
                insert: "top",
                container: "top-right",
                dismiss: { duration: 3000 }
            });
        }
    };

    loadPaymentDetails = async (listingId) => {
        if (this.state.paymentDetailsData[listingId]) return;

        const data = { ListingId: listingId };
        const result = await TokenPaymentsServices.getTokenPaymentDetails(data);
        if (result && result.status === 200) {
            this.setState(prevState => ({
                paymentDetailsData: {
                    ...prevState.paymentDetailsData,
                    [listingId]: {
                        propertyDetails: result.data.propertyDetails || [],
                        tenantPayment: result.data.tenantPayment || [],
                        bankDetails: result.data.bankDetails || [],
                        ownerSettlementDetails: result.data.ownerSettlementDetails || [],
                        refundDetails: result.data.refundDetails || []
                    }
                }
            }));
        }
    };

    /**
     * Shows a "View" link; on click, opens a popover with the full value + copy button
     */
    renderViewValue = (title, value, id) => {
        if (!value) return '-';
        const popover = (
            <Popover id={`popover-${id}`} style={{ maxWidth: '360px' }}>
                <Popover.Title as="h6" className="mb-0" style={{ fontSize: '12px' }}>{title}</Popover.Title>
                <Popover.Content>
                    <div className="d-flex align-items-center">
                        <code style={{ fontSize: '12px', color: '#1e293b', wordBreak: 'break-all', userSelect: 'all' }}>{value}</code>
                        <Button
                            variant="link"
                            size="sm"
                            className="ml-2 p-0"
                            title="Copy"
                            onClick={() => {
                                navigator.clipboard && navigator.clipboard.writeText(String(value));
                                store.addNotification({
                                    message: `${title} copied`,
                                    type: "success",
                                    insert: "top",
                                    container: "top-right",
                                    dismiss: { duration: 1500 }
                                });
                            }}
                        >
                            <i className="flaticon2-copy"></i>
                        </Button>
                    </div>
                </Popover.Content>
            </Popover>
        );
        return (
            <OverlayTrigger trigger="click" placement="top" rootClose overlay={popover}>
                <Button variant="link" size="sm" className="p-0" style={{ fontSize: '12px' }}>View</Button>
            </OverlayTrigger>
        );
    };

    renderDetails = (item) => {
        const listingId = item.ListingId;
        const details = this.state.paymentDetailsData[listingId];
        if (!details) {
            return <div className="text-center p-3">Loading details...</div>;
        }

        const bookingStatusId = item.BookingStatusId || 1;
        const bookingStatusText = item.BookingStatus || 'Token Generated';

        const steps = [
            { id: 1, label: 'Token Generated' },
            { id: 2, label: 'Token Paid' },
            { id: 3, label: 'Bank Details Added' },
            { id: 4, label: 'Token Amount Transferred' },
            { id: 5, label: 'Refunded' }
        ];

        return (
            <div className="p-3 bg-light" style={{ fontSize: '13px' }}>
                <Row className="mb-4">
                    <Col xs={12}>
                        <Card className="shadow-sm border-0">
                            <div className="d-flex justify-content-between align-items-center bg-white border-bottom" style={{ padding: '12px 20px' }}>
                                <h6 className="mb-0 font-weight-bold" style={{ fontSize: '14px' }}>Payment Journey</h6>
                                <TokenStatusPill statusId={bookingStatusId} text={bookingStatusText} />
                            </div>
                            <Card.Body className="p-4 overflow-auto">
                                {(() => {
                                    const statusId = Number(bookingStatusId);
                                    const isRefunded = statusId === 5;

                                    // done | current | skipped | pending
                                    const getStatus = (id) => {
                                        if (isRefunded) {
                                            if (id === 3 || id === 4) return 'skipped';
                                            return id === 5 ? 'current' : 'done';
                                        }
                                        // Amount transferred to owner => Refund step not applicable
                                        if (statusId === 4 && id === 5) return 'skipped';
                                        if (id < statusId) return 'done';
                                        if (id === statusId) return 'current';
                                        return 'pending';
                                    };

                                    const theme = {
                                        done: { bg: '#16a34a', border: '#16a34a', color: '#fff', label: '#166534', tag: 'Completed', tagBg: '#dcfce7', tagColor: '#166534' },
                                        current: { bg: isRefunded ? '#16a34a' : '#2563eb', border: isRefunded ? '#16a34a' : '#2563eb', color: '#fff', label: isRefunded ? '#166534' : '#1d4ed8', tag: isRefunded ? 'Completed' : 'Current', tagBg: isRefunded ? '#dcfce7' : '#dbeafe', tagColor: isRefunded ? '#166534' : '#1d4ed8' },
                                        skipped: { bg: '#fef2f2', border: '#fca5a5', color: '#dc2626', label: '#b91c1c', tag: 'Not Applicable', tagBg: '#fee2e2', tagColor: '#b91c1c' },
                                        pending: { bg: '#fff', border: '#cbd5e1', color: '#94a3b8', label: '#94a3b8', tag: 'Pending', tagBg: '#f1f5f9', tagColor: '#64748b' }
                                    };

                                    const completedCount = steps.filter(s => ['done', 'current'].includes(getStatus(s.id))).length;
                                    const progressPct = isRefunded ? 100 : Math.round((completedCount / steps.length) * 100);

                                    return (
                                        <div style={{ minWidth: '640px' }}>

                                            {/* Stepper */}
                                            <div className="d-flex" style={{ position: 'relative' }}>
                                                {steps.map((step, index) => {
                                                    const status = getStatus(step.id);
                                                    const t = theme[status];
                                                    const next = steps[index + 1];
                                                    const nextStatus = next ? getStatus(next.id) : null;

                                                    // Connector colour depends on where it leads
                                                    let connector = null;
                                                    if (next) {
                                                        let lineStyle = { borderTop: '3px solid #e2e8f0' };
                                                        if (status === 'skipped' || nextStatus === 'skipped') {
                                                            lineStyle = { borderTop: '3px dashed #fca5a5' };
                                                        } else if (nextStatus === 'done' || nextStatus === 'current') {
                                                            lineStyle = { borderTop: '3px solid #16a34a' };
                                                        }
                                                        connector = (
                                                            <div style={{ position: 'absolute', top: '19px', left: 'calc(50% + 26px)', width: 'calc(100% - 52px)', ...lineStyle }}></div>
                                                        );
                                                    }

                                                    let icon = <span>{step.id}</span>;
                                                    if (status === 'done' || (status === 'current' && isRefunded)) {
                                                        icon = <i className="flaticon2-check-mark" style={{ fontSize: '13px', color: '#fff' }}></i>;
                                                    } else if (status === 'skipped') {
                                                        icon = <i className="flaticon2-cross" style={{ fontSize: '11px', color: '#dc2626' }}></i>;
                                                    }

                                                    return (
                                                        <div key={step.id} style={{ flex: 1, textAlign: 'center', position: 'relative' }}>
                                                            {connector}
                                                            <div style={{
                                                                width: '40px', height: '40px', borderRadius: '50%', margin: '0 auto',
                                                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                                fontSize: '14px', fontWeight: 700, position: 'relative', zIndex: 1,
                                                                background: t.bg, color: t.color,
                                                                border: `2px ${status === 'skipped' ? 'dashed' : 'solid'} ${t.border}`,
                                                                boxShadow: status === 'current' ? `0 0 0 6px ${isRefunded ? '#dcfce7' : '#dbeafe'}` : 'none'
                                                            }}>
                                                                {icon}
                                                            </div>
                                                            <div style={{
                                                                marginTop: '14px', fontSize: '12px', fontWeight: status === 'pending' ? 500 : 600,
                                                                color: t.label, padding: '0 6px', lineHeight: 1.3,
                                                                textDecoration: status === 'skipped' ? 'line-through' : 'none'
                                                            }}>
                                                                {step.label}
                                                            </div>
                                                            <span style={{
                                                                display: 'inline-block', marginTop: '6px', padding: '2px 8px', borderRadius: '10px',
                                                                fontSize: '10px', fontWeight: 600, letterSpacing: '.3px', textTransform: 'uppercase',
                                                                background: t.tagBg, color: t.tagColor
                                                            }}>
                                                                {t.tag}
                                                            </span>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    );
                                })()}
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row className="mb-4">
                    <Col xs={12}>
                        <Card className="shadow-sm">
                            <Card.Header className="bg-white py-2">
                                <h6 className="mb-0">Tenant Payment Details <Badge variant="primary">{details.tenantPayment?.length || 0}</Badge></h6>
                            </Card.Header>
                            <Card.Body className="p-0">
                                <Table responsive hover className="mb-0">
                                    <thead className="thead-light">
                                        <tr>
                                            <th>Payment Id</th>
                                            <th>Amount</th>
                                            <th>Payment Through</th>
                                            <th>Payment Date</th>
                                            <th>Processing Fee</th>
                                            <th>PG Ref ID</th>
                                            <th>Created By</th>
                                            <th>Created On</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {details.tenantPayment?.length > 0 ? (
                                            details.tenantPayment.map((tp, idx) => (
                                                <tr key={idx}>
                                                    <td>{this.renderViewValue('Payment ID', tp.PaymentId, `pid-${listingId}-${idx}`)}</td>
                                                    <td>{formatAmount(tp.Amount)}</td>
                                                    <td>{tp.PaymentThrogh || '-'}</td>
                                                    <td>{tp.PaymentDate ? formatDateTime(tp.PaymentDate) : '-'}</td>
                                                    <td>{formatAmount(tp.ProcessingFee)}</td>
                                                    <td>{tp.TransRefNum || '-'}</td>
                                                    <td>{tp.CreatedBy || '-'}</td>
                                                    <td>{tp.CreatedOn || '-'}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr><td colSpan="8" className="text-center">No tenant payment records found</td></tr>
                                        )}
                                    </tbody>
                                </Table>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row className="mb-4">
                    <Col xs={12}>
                        <Card className="shadow-sm">
                            <Card.Header className="bg-white py-2">
                                <h6 className="mb-0">Bank Details <Badge variant="primary">{details.bankDetails?.length || 0}</Badge></h6>
                            </Card.Header>
                            <Card.Body className="p-0">
                                <Table responsive hover className="mb-0">
                                    <thead className="thead-light">
                                        <tr>
                                            <th>Account Name</th>
                                            <th>Account No</th>
                                            <th>IFSC Code</th>
                                            <th>Beneficiary ID</th>
                                            <th>Created On</th>
                                            <th>File Path</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {details.bankDetails?.length > 0 ? (
                                            details.bankDetails.map((bd, idx) => (
                                                <tr key={idx}>
                                                    <td>{bd.AccountName || '-'}</td>
                                                    <td>{bd.AccountNo || '-'}</td>
                                                    <td>{bd.IfscCode || '-'}</td>
                                                    <td>{bd.BeneficiaryId || '-'}</td>
                                                    <td>{bd.CreatedOn ? formatDateTime(bd.CreatedOn) : '-'}</td>
                                                    <td>{bd.FilePath ? <Button variant="link" size="sm" className="p-0" onClick={() => TokenPaymentsServices.openFile(bd.FilePath)}>View File</Button> : '-'}</td>
                                                    <td>
                                                        <Badge variant={bd.Status === 'Active' ? 'success' : 'secondary'}>{bd.Status || '-'}</Badge>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr><td colSpan="7" className="text-center">No bank records found</td></tr>
                                        )}
                                    </tbody>
                                </Table>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row className="mb-4">
                    <Col xs={12}>
                        <Card className="shadow-sm">
                            <Card.Header className="bg-white py-2">
                                <h6 className="mb-0">Owner Settlement Details <Badge variant="primary">{details.ownerSettlementDetails?.length || 0}</Badge></h6>
                            </Card.Header>
                            <Card.Body className="p-0">
                                <Table responsive hover className="mb-0">
                                    <thead className="thead-light">
                                        <tr>
                                            <th>Settled Amount</th>
                                            <th>Batch ID</th>
                                            <th>Merchant Ref ID</th>
                                            <th>Bank Ref ID</th>
                                            <th>UTR No</th>
                                            <th>Settlement Date</th>
                                            <th>Settled By</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {details.ownerSettlementDetails?.length > 0 ? (
                                            details.ownerSettlementDetails.map((osd, idx) => (
                                                <tr key={idx}>
                                                    <td>{formatAmount(osd.SettledAmount)}</td>
                                                    <td>{osd.BatchId || '-'}</td>
                                                    <td>{osd.MerchantRefId || '-'}</td>
                                                    <td>{osd.BankRefId || '-'}</td>
                                                    <td>{this.renderViewValue('UTR No', osd.UtrNo, `utr-${listingId}-${idx}`)}</td>
                                                    <td>{osd.SettlementDate ? formatDateTime(osd.SettlementDate) : '-'}</td>
                                                    <td>{osd.SettlementBy || '-'}</td>
                                                    <td><Badge variant="success">{osd.Status || '-'}</Badge></td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr><td colSpan="8" className="text-center">No settlement records found</td></tr>
                                        )}
                                    </tbody>
                                </Table>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row>
                    <Col xs={12}>
                        <Card className="shadow-sm">
                            <Card.Header className="bg-white py-2">
                                <h6 className="mb-0">Refund Details <Badge variant="primary">{details.refundDetails?.length || 0}</Badge></h6>
                            </Card.Header>
                            <Card.Body className="p-0">
                                <Table responsive hover className="mb-0">
                                    <thead className="thead-light">
                                        <tr>
                                            <th>Refund Amount</th>
                                            <th>Refund Ref ID</th>
                                            <th>Refund Status</th>
                                            <th>Refund Date</th>
                                            <th>Refund By</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {details.refundDetails?.length > 0 ? (
                                            details.refundDetails.map((rd, idx) => (
                                                <tr key={idx}>
                                                    <td>{formatAmount(rd.RefundAmount)}</td>
                                                    <td>{rd.RefundRefId || '-'}</td>
                                                    <td>{rd.RefundStatus || '-'}</td>
                                                    <td>{rd.RefundDate ? formatDateTime(rd.RefundDate) : '-'}</td>
                                                    <td>{rd.RefundBy || '-'}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr><td colSpan="5" className="text-center text-muted py-3">No refunds applicable for this token.</td></tr>
                                        )}
                                    </tbody>
                                </Table>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>
        );
    };


    getCities = async () => {
        const { cityIds } = this.state;
        const data = { pmsOperationStatus: 'YES' };
        const result = await commonServices.getCities(data);
        if (result && result.status === 200) {
            const cities = result?.data?.cities;
            const formattedCities = commonServices.formatCities(cities);
            let preSelectedCities = null;
            if (cityIds?.length > 0) {
                preSelectedCities = commonServices.preSelectCities(formattedCities, cityIds);
            }
            await this.setState({ formattedCities });
            preSelectedCities && await this.setState({ preSelectedCities });
        }
    };


    render() {
        const { isFetching, tokenPayments, filters, page, total, totalCount, formattedCities,
            preSelectedCities, } = this.state;
        let showPagination = false;
        if (total) { showPagination = total !== 0 && total !== 1; }

        return (
            <Container fluid>
                <Card>
                    <Card.Body>
                        <Portlet fluidHeight={true}>
                            <PortletHeader title={`All Token Payments (${totalCount || 0})`} />
                            <PortletBody>
                                <FilterComponent
                                    minimumDatetime={filters.minimumDatetime}
                                    maximumDatetime={filters.maximumDatetime}
                                    listingId={filters.listingId}
                                    tokenStatus={filters.tokenStatus}
                                    requestedFilters={['status', 'tokenStatus']}
                                    formattedCities={formattedCities}
                                    preSelectedCities={preSelectedCities}
                                    filterParentCallback={this.handleFilterChildData}
                                />

                                {isFetching ? (
                                    <div className="text-center p-3">{constants.LOADING_DATA}</div>
                                ) : (
                                    <div className="mt-4">
                                        {tokenPayments && tokenPayments.length === 0 && <p>{constants.ZERO_DATA}</p>}

                                        {tokenPayments && tokenPayments.length > 0 && (
                                            <div style={{ padding: '0 21px' }}>
                                                <Row className="align-items-center mb-2 text-muted" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>
                                                    <Col xs={4}><strong>PROPERTY & LISTING ID</strong></Col>
                                                    <Col xs={3}><strong>OWNER / TENANT(S)</strong></Col>
                                                    <Col xs={2}><strong>TOKEN AMOUNT</strong></Col>
                                                    <Col xs={2}><strong>STATUS</strong></Col>
                                                    <Col xs={1}></Col>
                                                </Row>
                                            </div>
                                        )}

                                        <Accordion>
                                            {tokenPayments && tokenPayments.map((item, index) => {
                                                const isOpen = this.state.openKey === item.ListingId;
                                                return (
                                                    <Card
                                                        key={item.ListingId}
                                                        className="mb-2"
                                                        style={{
                                                            border: '1px solid #e9ecef',
                                                            borderLeft: `4px solid ${isOpen ? '#2563eb' : '#e9ecef'}`,
                                                            borderRadius: '8px',
                                                            overflow: 'hidden',
                                                            boxShadow: isOpen ? '0 4px 12px rgba(0,0,0,0.08)' : '0 1px 3px rgba(0,0,0,0.04)'
                                                        }}
                                                    >
                                                        <Accordion.Toggle
                                                            as={Card.Header}
                                                            eventKey={String(item.ListingId)}
                                                            onClick={() => {
                                                                this.setState({ openKey: isOpen ? null : item.ListingId });
                                                                this.loadPaymentDetails(item.ListingId);
                                                            }}
                                                            style={{ cursor: 'pointer', backgroundColor: '#fff', border: 'none', padding: '12px 20px', transition: 'background-color 0.2s' }}
                                                            onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#f0fff4'; }}
                                                            onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#fff'; }}
                                                        >
                                                            <Row className="align-items-center">
                                                                <Col xs={4}>
                                                                    <div className="d-flex align-items-center">
                                                                        <div className="mr-3 p-2 bg-light rounded text-center" style={{ width: "40px", height: "40px" }}>
                                                                            <i className="flaticon2-architecture-and-city text-primary"></i>
                                                                        </div>
                                                                        <div>
                                                                            <div
                                                                                className="font-weight-bold text-primary"
                                                                                style={{ cursor: 'pointer', textDecoration: 'underline' }}
                                                                                title="Open Property Profile"
                                                                                onClick={(e) => this.openPropertyProfile(e, item.ListingId)}
                                                                            >
                                                                                {item.ListingName}
                                                                            </div>
                                                                            <div className="text-muted small">Listing ID #{item.ListingId}</div>
                                                                        </div>
                                                                    </div>
                                                                </Col>
                                                                <Col xs={3}>
                                                                    <div className="font-weight-bold text-dark">{item.OwnerName}</div>
                                                                    <div className="font-weight-bold text-dark">{item.TenantName}</div>
                                                                </Col>
                                                                <Col xs={2}>
                                                                    <div className="font-weight-bold text-dark">{formatAmount(item.TokenAmount)}</div>
                                                                    <div className="text-muted small">Move-in: {item.MoveInDate}</div>
                                                                </Col>
                                                                <Col xs={2}>
                                                                    <TokenStatusPill statusId={item.BookingStatusId} text={item.BookingStatus} />
                                                                </Col>
                                                                <Col xs={1} className="text-right text-muted">
                                                                    <i className="fa fa-chevron-down" style={{ transition: 'transform 0.2s', transform: isOpen ? 'rotate(180deg)' : 'none' }}></i>
                                                                </Col>
                                                            </Row>
                                                        </Accordion.Toggle>
                                                        <Accordion.Collapse eventKey={String(item.ListingId)}>
                                                            <Card.Body className="p-0" style={{ borderTop: '1px solid #e9ecef' }}>
                                                                {this.renderDetails(item)}
                                                            </Card.Body>
                                                        </Accordion.Collapse>
                                                    </Card>
                                                );
                                            })}
                                        </Accordion>

                                        {/* Pagination */}
                                        {showPagination && (
                                            <div className="d-flex justify-content-end mt-4">
                                                <UltimatePagination
                                                    currentPage={page}
                                                    totalPages={total}
                                                    onChange={this.onPageChange}
                                                />
                                            </div>
                                        )}
                                    </div>
                                )}
                            </PortletBody>
                        </Portlet>
                    </Card.Body>
                </Card>
            </Container>
        );
    }
}

const mapStateToProps = state => ({
    userDetails: state.auth && state.auth.user
});

export default withRouter(connect(mapStateToProps, null)(TokenPayments));
